import { type FC, type ReactNode } from "react";

import { type PreviewAspectRatio } from "../models";

import { LensPreviewText } from "./LensPreviewForm.styles";
import {
    GuideLink,
    RequirementsList,
    RequirementsListItem,
    SpecHeader,
    lensPreviewFormSpecs,
} from "./LensPreviewSpecs.styles";
import {
    AspectRatio,
    BestPractices,
    ImageSize,
    LinkText,
    Resolution,
    SpecificationsHeading,
    TipsHeading,
    TipsTextLineOne,
    TipsTextLineTwo,
    VideoMinLength,
    VideoSize,
} from "./messages.generated";

interface LensPreviewSpecsProps {
    aspectRatio: PreviewAspectRatio;
    resolution: string;
    acceptsVideo?: boolean;
    acceptsImages?: boolean;
    guideUrl: string;
    /** Replaces the default duration copy when the flow uses a stricter video requirement. */
    videoDurationSpec?: ReactNode;
}

export const LensPreviewSpecs: FC<LensPreviewSpecsProps> = ({
    aspectRatio,
    resolution,
    acceptsVideo = true,
    acceptsImages = true,
    guideUrl,
    videoDurationSpec,
}) => (
    <div className={lensPreviewFormSpecs}>
        <SpecHeader>
            <SpecificationsHeading />
        </SpecHeader>
        <LensPreviewText>
            <AspectRatio aspectRatio={aspectRatio} />
        </LensPreviewText>
        {acceptsVideo && (
            <LensPreviewText>
                <Resolution resolution={resolution} />
            </LensPreviewText>
        )}
        <RequirementsList>
            {acceptsVideo && (
                <RequirementsListItem>
                    <span>
                        <VideoSize />
                    </span>
                </RequirementsListItem>
            )}
            {acceptsVideo && (
                <RequirementsListItem>
                    <span>{videoDurationSpec ?? <VideoMinLength />}</span>
                </RequirementsListItem>
            )}
            {acceptsImages && (
                <RequirementsListItem>
                    <span>
                        <ImageSize />
                    </span>
                </RequirementsListItem>
            )}
        </RequirementsList>
        <SpecHeader>
            <TipsHeading />
        </SpecHeader>
        {acceptsVideo && (
            <LensPreviewText>
                <TipsTextLineOne />
            </LensPreviewText>
        )}
        <LensPreviewText>
            <TipsTextLineTwo />
        </LensPreviewText>
        <LensPreviewText>
            <BestPractices />
            <GuideLink href={guideUrl} target="_blank">
                <LinkText />
            </GuideLink>
        </LensPreviewText>
    </div>
);
